import axios from "../services/api/api";
import { formatDate, dateAddYears } from "../Utilities/dateUtils";

/** HELPER FUNCTIONS **/

const appendIfNotNull = (formData, name, value) => {
  if (value != null) {
    formData.append(name, value);
  }
};
/** END HELPER FUNCTIONS **/

export const PostNotification = async (values) => {
  var myData = new FormData();
  appendIfNotNull(myData, "ImageFile", values.postObject.image);
  if (values.postObject.forSchools !== null) {
    values.postObject.forSchools.forEach((item) => {
      myData.append("SchoolIds", item);
    });
  }
  values.postObject.forLicenses.forEach((item) => {
    myData.append("ProgramIds", item);
  });
  myData.append("ShowForAllCustomers", values.postObject.showForAllCustomers);
  myData.append("ShowForTeachers", values.postObject.showForTeachers);
  myData.append("ShowForStudents", values.postObject.showForStudents);
  myData.append("ShowFrom", values.postObject.showFrom);
  appendIfNotNull(myData, "Title", values.postObject.title);
  appendIfNotNull(myData, "Text", values.postObject.text);
  appendIfNotNull(myData, "Video", values.postObject.video);
  myData.append("IsIntrusive", values.postObject.isIntrusive);

  const data = await axios.post(`/User/CreateNotice`, myData, {
    headers: { "Content-Type": "multipart/form-data;" },
  });
  return data;
};

export const ReplaceManual = async ({ fileName, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.put(
    `/Manual/${encodeURIComponent(fileName)}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return res.data.result;
};

export const UpdateNotification = async (values) => {
  var myData = new FormData();
  appendIfNotNull(myData, "ImageFile", values.postObject.image);
  myData.append("noticeId", values.postObject.noticeId);
  if (values.postObject.forSchools !== null) {
    values.postObject.forSchools.forEach((item) => {
      myData.append("SchoolIds", item);
    });
  }
  values.postObject.forLicenses.forEach((item) => {
    myData.append("ProgramIds", item);
  });
  myData.append("ShowForAllCustomers", values.postObject.showForAllCustomers);
  myData.append("ShowForTeachers", values.postObject.showForTeachers);
  myData.append("ShowForStudents", values.postObject.showForStudents);
  myData.append("ShowFrom", values.postObject.showFrom);
  appendIfNotNull(myData, "Title", values.postObject.title);
  appendIfNotNull(myData, "Text", values.postObject.text);
  appendIfNotNull(myData, "Video", values.postObject.video);
  myData.append("IsIntrusive", values.postObject.isIntrusive);
  myData.append("ImageOptions", values.postObject.imageOptions);
  const data = await axios.post(`/User/UpdateNotice`, myData, {
    headers: { "Content-Type": "multipart/form-data;" },
  });
  return data;
};

export const SetCourseModuleSortOrder = async (postData) => {
  const data = await axios.post("/Course/SetModuleOrder", {
    ParentId: postData.courseId,
    SortedChildIds: postData.orderedModuleIds,
  });
  return data;
};

export const EditSchoolName = async (updateObject) => {
  const data = await axios.put(
    `/School/Update?schoolId=${updateObject.id}&name=${encodeURIComponent(
      updateObject.name,
    )}`,
  );
  return data;
};

export const AddProgramToSchool = async (updateObject) => {
  const data = axios.post(`/programme`, {
    name: updateObject.license.programName,
    customer: updateObject.school,
    costCenter: updateObject.license.fortNoxCostCenter,
  });
  return data;
};

export const AddProgramLicenseToSchool = async (updateObject) => {
  const validTo = formatDate(dateAddYears(new Date(), 3), "yyyy-MM-dd'T'HH:mm:ss");
  const data = axios.post(
    `/ProgramLicense?customerId=${
      updateObject.school.id
    }&fortNoxNumber=${updateObject.license.fortNoxProgramLicenseNumber.trim()}&fortNoxNumberStudent=${(updateObject.license.fortNoxStudentProgramLicenseNumber ?? "").trim()}&fortNoxCostCenter=${
      updateObject.license.fortNoxCostCenter
    }&validTo=${validTo}`,
  );
  return data;
};

export const CreateSchoolAndAssignProgram = async (updateObject) => {
  const data = await axios.post(
    `/School/Create?customerNumber=${updateObject.fortKnoxCustomerNumber}`,
  );
  return data;
};

export const CreateNewTeacher = async (postObject) => {
  const data = await axios.post(
    `/Teacher?${postObject.classIds.map((id) => `classIds=${id}`).join("&")}`,
    postObject.teacherToPost,
  );
  return data;
};

export const AddClassToSchool = async (postObject) => {
  const data = await axios.post("/class", {
    name: postObject.name,
    school: postObject.school,
    programme: postObject.selectedProgramme,
    orientation: { id: 0, name: postObject.selectedOrientation },
  });
  return data;
};

export const CreateNewScormLicenseCustomer = async (postObject) => {
  const data = await axios.post(
    `/LicMgt/CreateCustomer?FortNoxNumber=${postObject.fortnoxNumber}&Url=${postObject.url}&ContactName=${postObject.contactName}&ContactMail=${postObject.contactMail}`,
  );
  return data;
};

export const CreateNewScormLicenseCourse = async (postObject) => {
  const additionalInfoParam = postObject.additionalInfo
    ? `&AdditionalInfo=${encodeURIComponent(postObject.additionalInfo)}`
    : "";
  const data = await axios.post(
    `/LicMgt/CreateCourse?Name=${postObject.name}&identifier=${postObject.identifier}${additionalInfoParam}`,
  );
  return data;
};

export const CreateNewScormLicenseLicenses = async (postObject) => {
  const data = await axios.post(
    `/LicMgt/CreateLicenses?CourseId=${postObject.courseId}&CustomerId=${postObject.customerId}&Quantity=${postObject.quantity}`,
  );
  return data;
};

export const UpdateLicenseCustomer = async (postObject) => {
  const data = await axios.post(
    `/LicMgt/UpdateCustomer?FortNoxNumber=${postObject.fortnoxNumber}&Url=${postObject.url}&ContactName=${postObject.contactName}&ContactMail=${postObject.contactMail}`,
  );
  return data;
};

export const UpdateLicenseCourse = async (postObject) => {
  const additionalInfoParam = postObject.additionalInfo
    ? `&AdditionalInfo=${encodeURIComponent(postObject.additionalInfo)}`
    : "";
  const data = await axios.post(
    `/LicMgt/UpdateCourse?Id=${postObject.id}&Identifier=${postObject.identifier}&Name=${postObject.name}${additionalInfoParam}`,
  );
  return data;
};

export const SetCourseSortOrder = async (postData) => {
  const data = await axios.post("/Course/SetCourseOrder", {
    ParentId: postData.programId,
    SortedChildIds: postData.orderedCourseIds,
  });
  return data;
};

export const AddNewProgram = async (postData) => {
  const data = await axios.post(`/ProgramLicense/AddFortNoxProgram`, postData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const EditProgramLicense = async (postData) => {
  const data = await axios.put(`/ProgramLicense/EditFortNoxProgram`, postData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const EditSchoolGrouping = async (postData) => {
  const data = await axios.put(
    `/School/EditSchoolGrouping`,
    JSON.stringify(postData.customers, null, 1),
    { headers: { "Content-Type": "application/json" } },
  );
  return data;
};

export const EditSchoolGroupName = async (postData) => {
  const data = await axios.put(`/School/EditGroup`, {
    Id: postData.id,
    Name: postData.name,
  });
  return data;
};

export const CreateSchoolGroup = async (postData) => {
  const data = await axios.post(`/School/CreateGroup/${postData.name}`);
  return data;
};

export const DeleteSchoolGroup = async (postData) => {
  const data = await axios.delete(
    `/School/DeleteSchoolGroup?groupId=${postData.groupId}`,
  );
  return data;
};
